import { render, staticRenderFns } from "./DiagramForkBtn.vue?vue&type=template&id=25a3c5ca&"
import script from "./DiagramForkBtn.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiagramForkBtn.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DiagramForkBtn.vue?vue&type=style&index=0&id=25a3c5ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports